import type { District } from '../plot.ts'
import { decals, look, woodsy } from '../kit.ts'

/** The Meadow running down to Sunny Shore: wildflowers, a bandstand, a campfire and the beach. */
export const meadow: District = {
  id: 'meadow',
  name: 'Meadow & Shore',
  ground: 'grass',
  ambience: ['fireflies', 'gulls'],
  build(p) {
    p.zone(0, 20, 36, 6, 'sand'); p.zone(0, 25, 36, 1, 'wetsand'); p.zone(0, 26, 36, 6, 'sea')
    p.zone(17, 0, 2, 20, 'dirt')
    p.prop(
      { kind: 'campfire', x: 10, y: 8 },
      { kind: 'stump', x: 9, y: 8, face: 1 }, { kind: 'stump', x: 11, y: 8, face: -1 }, { kind: 'stump', x: 10, y: 7, face: 1 }, { kind: 'stump', x: 10, y: 9, face: -1 },
      { kind: 'gazebo', x: 25, y: 5 },
      { kind: 'picnic', x: 21, y: 12, color: '#ffd166' },
      { kind: 'parasol', x: 6, y: 22, color: '#ff6b8b' }, { kind: 'towel', x: 5, y: 22, color: '#6ec6ff', face: 1 }, { kind: 'towel', x: 7, y: 22, color: '#ffd166', face: -1 },
      { kind: 'parasol', x: 14, y: 22, color: '#4fc3a1' }, { kind: 'towel', x: 13, y: 22, color: '#ff8fab', face: 1 }, { kind: 'towel', x: 15, y: 22, color: '#b69cff', face: -1 },
      { kind: 'parasol', x: 29, y: 22, color: '#ffc35c' }, { kind: 'towel', x: 28, y: 22, color: '#7cf29c', face: 1 },
      { kind: 'sandcastle', x: 22, y: 23 },
      { kind: 'palm', x: 2, y: 21 }, { kind: 'palm', x: 33, y: 21 }, { kind: 'palm', x: 25, y: 20 },
      { kind: 'signpost', x: 16, y: 19, text: 'Sunny Shore' },
    )
    p.tram(30, 14)
    p.place({ id: 'meadow', name: 'The Meadow', blurb: 'Wildflowers, a bandstand and a crackling fire.', x: 12, y: 11, accent: '#9fd36b', r: 9 })
    p.place({ id: 'beach', name: 'Sunny Shore', blurb: 'Warm sand and waves that never stop.', x: 19, y: 23, accent: '#ffc35c', r: 9 })
    p.scatter({ density: 0.1, pick: woodsy([['flowers', 5], ['tree', 3], ['bush', 2]]), on: ['grass'] })
    p.critter({ kind: 'crab', loop: [[2.5, 25.5], [12, 25.6], [20.5, 25.4], [10, 25.5]], speed: 0.5 })
    p.critter({ kind: 'butterfly', loop: [[3, 3], [14, 5], [12, 15], [2, 14]], speed: 0.6 })
    p.npc({
      id: 'npc-sunny', name: 'Sunny', role: 'Lifeguard', look: look('lifesunny', 2, 0, 4, 'snorkel'), speed: 1.4,
      stops: [{ x: 4, y: 24, wait: 10, say: -1 }, { x: 31, y: 24, wait: 10, emote: 'smug', say: -1 }, { x: 19, y: 21, wait: 8 }],
      lines: ['No running on the sand!', 'Water’s perfect today.', 'Sunscreen, everyone!', 'I’ve got my eye on that crab.'],
    })

    // ─── Detail ───
    p.scatter(decals(['clover', 'clover'], 0.08, ['grass']))
    p.scatter(decals(['shells', 'shells', 'seaweed'], 0.08, ['sand', 'wetsand']))
    p.prop(
      { kind: 'cart', x: 23, y: 19, color: '#ff8fab', text: 'Ice cream' }, { kind: 'stump', x: 30, y: 20, face: -1 },
      { kind: 'parasol', x: 9, y: 23, color: '#7cf29c' }, { kind: 'towel', x: 10, y: 22, color: '#ff6b8b', face: -1 },
      { kind: 'festoon', x: 24, y: 9, w: 5, d: 1 },
    )
    p.npc({
      id: 'npc-kite', name: 'Kai', role: 'Beachgoer', look: look('beachkai', 2, 9, 4, 'snorkel'), speed: 1.6,
      stops: [{ x: 11, y: 24, wait: 15, emote: 'happy', say: -1 }, { x: 26, y: 24, wait: 15 }, { x: 22, y: 21, wait: 10, say: -1 }],
      lines: ['The water is SO cold. Come in!', 'Ice cream first, swim later.', 'I buried my sandal somewhere here.'],
    })
  },
}
